import { HexColor } from 'terra-draw';
import { Action } from '@/OptimusRoutes/components/terraDraw/store/actions';
import { ActionType } from '@/types/actionType';
import { DrawFeature } from '@/utilities/map.utils';

type State = {
	isPanelActive: boolean;
	selectedFeatures: DrawFeature[];
	feature: DrawFeature | null;
	color: HexColor;
};

const INITIAL_STATE: State = {
	isPanelActive: false,
	selectedFeatures: [],
	feature: null,
	color: '#ed1b24' as HexColor,
};

const TerraDrawReducer = (state: State = INITIAL_STATE, action: Action): State => {
	switch (action.type) {
		case ActionType.TERRA_DRAW_SET_IS_PANEL_ACTIVE:
			return {
				...state,
				isPanelActive: action.payload,
			};

		case ActionType.TERRA_DRAW_SET_SELECTED_FEATURES:
			return {
				...state,
				selectedFeatures: action.payload,
			};

		case ActionType.TERRA_DRAW_SET_FEATURE:
			return {
				...state,
				feature: action.payload,
			};

		case ActionType.TERRA_DRAW_SET_COLOR:
			return {
				...state,
				color: action.payload,
			};

		case ActionType.TERRA_DRAW_CLEAR:
			return {
				...state,
				feature: null,
			};

		case ActionType.TERRA_DRAW_RESET:
			return INITIAL_STATE;

		default:
			return state;
	}
};

export default TerraDrawReducer;
